

import React, { memo } from 'react';
import cx from 'classnames';
import { TAG, DISABLED_TAG, INVALID_TAG, ICON } from '../styles/tag';
import Icon from '../../Icon';









function Tag({ onClick, tagName, className, disabled, valid }) {
  return (
    <div className={cx(
      'tag',
      TAG,
      className,
      { tag__disabled: disabled, [DISABLED_TAG]: disabled },
      { tag__invalid: !valid, [INVALID_TAG]: !valid }
    )}>

      <p className="tag__text">{tagName}</p>
      {!disabled ? <Icon onClick={onClick} className={cx(ICON)} name="close" size={10} color="parthenon" /> : null}
    </div>);

}

export default memo(Tag);